import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import HeroBanner from '../components/HeroBanner';
import { FiPhone, FiSend } from 'react-icons/fi';
import { MdShoppingCart } from 'react-icons/md';
import { IoIosClose } from 'react-icons/io';
import { FaBars } from 'react-icons/fa';
import { FaWhatsapp } from 'react-icons/fa';
import { AiOutlineUser } from 'react-icons/ai';
import axios from 'axios';
import { apiClient } from '../config/apiConfig';

interface CartItem {
  cartItemsId: number;
  cartId: number;
  productId: number;
  productName: string;
  productImage: string;
  variantId?: number;
  variantName?: string;
  productPrice: number;
  variantPrice?: number;
  quantity: number;
  weight?: number;
  unit?: string;
}


const Cart: React.FC = () => {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [customerName, setCustomerName] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const name = localStorage.getItem("customerName");
    if (name && name.trim() !== "" && name !== "undefined") {
      setCustomerName(name);
    } else {
      setCustomerName(null);
    }
  }, []);
  const fetchCart = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        console.error("No customerId found in localStorage");
        return;
      }

      const response = await apiClient.get(
        `/Cart/GetCartByCustomerId?customerId=${customerId}`
      );

      console.log("Cart data:", response.data);
      console.log("Cart items:", response.data.items);

      // ✅ Debug: Log weight data for each item
      response.data.items.forEach((item: CartItem, index: number) => {
        console.log(`Item ${index}: ${item.productName}`, {
          variantId: item.variantId,
          weight: item.weight,
          unit: item.unit
        });
      });

      // ✅ directly set items (API already shaped as items[])
      setCartItems(response.data.items || []);

    } catch (error) {
      console.error("Error fetching cart items:", error);
    } finally {
      setLoading(false); // ✅ stop loading spinner
    }
  };

  useEffect(() => {
    fetchCart();
    // Hide loader if present
    const loader = document.getElementById('ftco-loader');
    if (loader) loader.classList.remove('show');


    // Re-initialize AOS
    if (window.AOS) window.AOS.init();
    const script = document.createElement('script');
    script.src = '/js/main.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handleRemoveFromCart = async (cartItemId?: number) => {
    if (!cartItemId) {
      console.error("Cart item ID is missing");
      return;
    }

    try {
      await apiClient.delete(`/Cart/RemoveCartItem/${cartItemId}`);
      setCartItems((prev) => prev.filter((item) => item.cartItemsId !== cartItemId));
    } catch (error) {
      console.error("Error removing cart item:", error);
    }
  };
  const handleIncrease = async (item: CartItem) => {
    const newQty = item.quantity + 1;

    // Optimistic UI update
    setCartItems(prev =>
      prev.map(i =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: newQty }
          : i
      )
    );

    try {
      await apiClient.put(`/Cart/UpdateQuantity`, {
        cartItemsId: item.cartItemsId,
        quantity: newQty,
      });
    } catch (error) {
      console.error("Increase failed", error);

      // rollback if API fails
      setCartItems(prev =>
        prev.map(i =>
          i.cartItemsId === item.cartItemsId
            ? { ...i, quantity: item.quantity }
            : i
        )
      );
    }
  };
  const handleDecrease = async (item: CartItem) => {
    if (item.quantity <= 1) return;

    const newQty = item.quantity - 1;

    setCartItems(prev =>
      prev.map(i =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: newQty }
          : i
      )
    );

    try {
      await apiClient.put(`/Cart/UpdateQuantity`, {
        cartItemsId: item.cartItemsId,
        quantity: newQty,
      });
    } catch (error) {
      console.error("Decrease failed", error);

      // rollback
      setCartItems(prev =>
        prev.map(i =>
          i.cartItemsId === item.cartItemsId
            ? { ...i, quantity: item.quantity }
            : i
        )
      );
    }
  };
  // Helper function to get the effective price (variant price if available, otherwise product price)
  const getItemPrice = (item: CartItem): number => item.variantPrice || item.productPrice;

  const subtotal = cartItems.reduce(
    (sum, item) => sum + getItemPrice(item) * item.quantity,
    0
  );

  const delivery = 0; // can make dynamic later
  const discount = 0; // can apply coupon logic later
  const total = subtotal + delivery - discount;
  const totalCount = cartItems.length; // unique product count only
  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-0 bg-primary w-100" style={{ padding: '0.3rem 0' }}>
        <div className="container">
          <div className="row d-flex align-items-center text-white">
            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiPhone size={14} className="mr-2" />
              <span>+91 9148761750</span>
            </div>

            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiSend size={14} className="mr-2" />
              <span>care@fhome.shop</span>
            </div>

            <div className="col-12 col-md text-md-right">
              <span>3-5 Business days delivery & Free Returns</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar" style={{ padding: '0.4rem 0' }}>
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "48px", marginRight: "8px", borderRadius: "50%", width: "70px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>
          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item"><a href="/" className="nav-link">Home</a></li>
              <li className="nav-item active dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                  <a className="dropdown-item" href="/wishlist">Wishlist</a>
                  <a className="dropdown-item" href="/product-single">Single Product</a>
                  <a className="dropdown-item" href="/cart">Cart</a>
                  <a className="dropdown-item" href="/checkout">Checkout</a>
                  <a className="dropdown-item" href="/my-orders">Orders</a>
                </div>
              </li>
              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              {/* <li className="nav-item"><a href="/blog" className="nav-link">Blog</a></li> */}
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>
              <li className="nav-item cta cta-colored"> <a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [{totalCount}]
              </a></li>
              <li className="nav-item">
                <a
                  href="/my-account"
                  className="nav-link d-flex align-items-center"
                  style={{ gap: "6px" }}
                >
                  <AiOutlineUser size={24} style={{ color: "#898989" }} />

                  {customerName ? (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999",
                        maxWidth: "120px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis"
                      }}
                      title={`Hi, ${customerName}`}
                    >
                      Hi, {customerName}
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#999"
                      }}
                    >
                      Login
                    </span>
                  )}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <HeroBanner image="images/fhome-ghee-sweets.jpg" padding="1.5rem 0">
        <div className="row no-gutters slider-text align-items-center justify-content-center">
          <div className="col-md-9 ftco-animate text-center">
            <p className="breadcrumbs" style={{ marginBottom: '0.2rem', fontSize: '0.9rem' }}><span className="mr-2"><a href="/">Home</a></span> <span>Cart</span></p>
            <h1 className="mb-0 bread" style={{ fontSize: '2rem' }}>My Cart</h1>
          </div>
        </div>
      </HeroBanner>

      {/* Cart Section */}
      <section className="ftco-section ftco-cart" style={{ padding: '1.5rem 0' }}>
        <div className="container">
          <div className="row" style={{ marginBottom: '0' }}>
            <div className="col-lg-8 ftco-animate">
              <div className="cart-list">
                <table className="table">
                  <thead className="thead-primary">
                    <tr className="text-center" style={{ fontSize: '0.85rem', lineHeight: '1' }}>
                      <th style={{ padding: '0.25rem 0.2rem' }}>&nbsp;</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>&nbsp;</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>Product</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>Weight</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>Price</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>Qty</th>
                      <th style={{ padding: '0.25rem 0.2rem' }}>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cartItems.map((item) => (
                      <tr className="text-center" key={item.cartItemsId} style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
                        {/* Remove */}
                        <td className="product-remove" style={{ padding: '0.25rem 0.2rem' }}>
                          <button
                            type="button"
                            onClick={() => handleRemoveFromCart(item.cartItemsId)}
                            className="text-red-600 hover:text-red-800"
                            style={{
                              background: "#ffe8e8",
                              border: "1.5px solid #ff6b6b",
                              cursor: "pointer",
                              borderRadius: '50%',
                              padding: '4px 5px',
                              color: '#ff6b6b',
                              fontSize: '0.9rem',
                              fontWeight: '600',
                              transition: 'all 0.3s ease',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              minWidth: '28px',
                              height: '28px',
                              width: '28px'
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = '#ff6b6b';
                              e.currentTarget.style.color = 'white';
                              e.currentTarget.style.boxShadow = '0 2px 8px rgba(255, 107, 107, 0.3)';
                              e.currentTarget.style.transform = 'scale(1.1)';
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = '#ffe8e8';
                              e.currentTarget.style.color = '#ff6b6b';
                              e.currentTarget.style.boxShadow = 'none';
                              e.currentTarget.style.transform = 'scale(1)';
                            }}
                          >
                            ✕
                          </button>
                        </td>

                        {/* Image */}
                        <td className="image-prod" style={{ padding: '0.25rem 0.2rem' }}>
                          <img
                            src={`https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net${item.productImage}`}
                            alt={item.productName}
                            style={{ width: "65px", height: "65px", objectFit: "cover" }}
                          />
                        </td>

                        {/* Name + Variant */}
                        <td className="product-name" style={{ padding: '0.25rem 0.2rem' }}>
                          <h3 style={{ marginBottom: '0.2rem', fontSize: '0.9rem' }}>
                            {item.productName}
                            {item.variantName && (
                              <span style={{ fontSize: '0.75rem', color: '#777', marginLeft: '4px' }}>
                                ({item.variantName})
                              </span>
                            )}
                          </h3>
                        </td>

                        {/* Weight */}
                        <td className="weight" style={{ padding: '0.25rem 0.2rem' }}>
                          {item.weight !== null && item.weight !== undefined && item.weight > 0 ? (
                            <p style={{ fontSize: '0.85rem', margin: 0, color: '#555', fontWeight: '500' }}>
                              {item.weight} {item.unit || 'g'}
                            </p>
                          ) : (
                            <p style={{ fontSize: '0.85rem', margin: 0, color: '#ccc' }}>—</p>
                          )}
                        </td>

                        {/* Price */}
                        <td className="price" style={{ padding: '0.25rem 0.2rem' }}>
                          ₹{getItemPrice(item).toFixed(2)}
                        </td>

                        {/* Quantity */}
                        <td className="quantity" style={{ padding: '0.25rem 0.2rem' }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                            <button
                              onClick={() => handleDecrease(item)}
                              style={{
                                backgroundColor: "#e8f5e9",
                                border: "1.5px solid #28a745",
                                borderRadius: "50%",
                                padding: "3px 5px",
                                cursor: "pointer",
                                fontSize: '0.8rem',
                                color: '#28a745',
                                fontWeight: '700',
                                transition: 'all 0.3s ease',
                                minWidth: '26px',
                                height: '26px',
                                width: '26px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#28a745';
                                e.currentTarget.style.color = 'white';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(40, 167, 69, 0.3)';
                                e.currentTarget.style.transform = 'scale(1.1)';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#e8f5e9';
                                e.currentTarget.style.color = '#28a745';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              −
                            </button>
                            <span style={{ minWidth: '24px', textAlign: 'center', fontSize: '0.85rem', fontWeight: '600', color: '#2c3e50' }}>{item.quantity}</span>
                            <button
                              onClick={() => handleIncrease(item)}
                              style={{
                                backgroundColor: "#e8f5e9",
                                border: "1.5px solid #28a745",
                                borderRadius: "50%",
                                padding: "3px 5px",
                                cursor: "pointer",
                                fontSize: '0.8rem',
                                color: '#28a745',
                                fontWeight: '700',
                                transition: 'all 0.3s ease',
                                minWidth: '26px',
                                height: '26px',
                                width: '26px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.backgroundColor = '#28a745';
                                e.currentTarget.style.color = 'white';
                                e.currentTarget.style.boxShadow = '0 2px 8px rgba(40, 167, 69, 0.3)';
                                e.currentTarget.style.transform = 'scale(1.1)';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.backgroundColor = '#e8f5e9';
                                e.currentTarget.style.color = '#28a745';
                                e.currentTarget.style.boxShadow = 'none';
                                e.currentTarget.style.transform = 'scale(1)';
                              }}
                            >
                              +
                            </button>
                          </div>
                        </td>
                        {/* Total */}
                        <td className="total" style={{ padding: '0.25rem 0.2rem' }}>
                          ₹{(getItemPrice(item) * item.quantity).toFixed(2)}
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Mobile stacked list for small screens */}
              <div className="cart-list-mobile" style={{ display: 'none' }}>
                {cartItems.map((item) => (
                  <div className="cart-item" key={`mobile-${item.cartItemsId}`} style={{ display: 'flex', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid #eee' }}>
                    <button
                      onClick={() => handleRemoveFromCart(item.cartItemsId)}
                      aria-label="Remove item"
                      style={{ background: 'none', border: 'none', fontSize: 20, marginRight: 10, color: '#c0392b' }}
                    >
                      ✕
                    </button>
                    <img src={`https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net${item.productImage}`} alt={item.productName} style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 6, marginRight: 12 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <h4 style={{ margin: 0, fontSize: 16 }}>{item.productName}</h4>
                          {item.variantName && <div style={{ fontSize: 13, color: '#777' }}>{item.variantName}</div>}
                          {item.weight && <div style={{ fontSize: 12, color: '#999' }}>{item.weight}</div>}
                        </div>
                        <div style={{ fontWeight: 600 }}>₹{getItemPrice(item).toFixed(2)}</div>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8 }}>
                        <div className="qty-controls" style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <button onClick={() => handleDecrease(item)} style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc', background: '#f7f7f7' }}>-</button>
                          <div style={{ minWidth: 24, textAlign: 'center' }}>{item.quantity}</div>
                          <button onClick={() => handleIncrease(item)} style={{ padding: '6px 10px', borderRadius: 6, border: '1px solid #ccc', background: '#f7f7f7' }}>+</button>
                        </div>
                        <div style={{ fontWeight: 700 }}>₹{(getItemPrice(item) * item.quantity).toFixed(2)}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Responsive styles to toggle table / mobile list */}
              <style>{`
                @media (max-width: 767px) {
                  .table { display: none !important; }
                  .cart-list-mobile { display: block !important; }
                  .cart-total .d-flex { flex-direction: column; align-items: flex-start; gap: 6px; }
                  .cart-total .btn { width: 100%; }
                }
                @media (min-width: 768px) {
                  .cart-list-mobile { display: none !important; }
                }
              `}</style>
            </div>
            <div className="col-lg-4 ftco-animate" style={{ marginTop: '0' }}>
              {/* Existing cart content */}
              <div className="cart-wrap" style={{ marginTop: '0' }}>
                <div className="cart-total mb-2" style={{ padding: '1rem' }}>
                  <h3 style={{ marginBottom: '0.6rem', fontSize: '1.15rem', fontWeight: '600' }}>Order Summary</h3>
                  <p className="d-flex" style={{ marginBottom: '0.4rem', fontSize: '0.9rem', justifyContent: 'space-between' }}>
                    <span>Subtotal</span>
                    <span>₹{subtotal.toFixed(2)}</span>
                  </p>
                  <p className="d-flex" style={{ marginBottom: '0.4rem', fontSize: '0.9rem', justifyContent: 'space-between' }}>
                    <span>Delivery</span>
                    <span>₹{delivery.toFixed(2)}</span>
                  </p>
                  <p className="d-flex" style={{ marginBottom: '0.4rem', fontSize: '0.9rem', justifyContent: 'space-between' }}>
                    <span>Discount</span>
                    <span>₹{discount.toFixed(2)}</span>
                  </p>
                  <hr style={{ margin: '0.5rem 0' }} />
                  <p className="d-flex total-price" style={{ marginBottom: '0.75rem', fontSize: '1.05rem', fontWeight: '700', justifyContent: 'space-between' }}>
                    <span>Total</span>
                    <span>₹{total.toFixed(2)}</span>
                  </p>
                </div>
                <p style={{ marginBottom: '0.4rem' }}><a href="/shop" className="btn btn-outline-dark py-2 px-3" style={{ fontSize: '0.9rem' }}>← Continue Shopping</a></p>
                <p style={{ marginBottom: '0' }}><a href="/checkout" className="btn btn-primary py-2 px-3" style={{ fontSize: '0.9rem' }}>Proceed to Checkout</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Newsletter Section */}
      <section className="ftco-section ftco-no-pt ftco-no-pb py-3 bg-light">
        <div className="container py-2">
          <div className="row d-flex justify-content-center py-2">
            <div className="col-md-6">
              <h2 style={{ fontSize: '1rem', marginBottom: '0.2rem', fontWeight: '600' }}>Subscribe to our Newsletter</h2>
              <span style={{ fontSize: '0.85rem' }}>Get updates on latest offers</span>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <form action="#" className="subscribe-form">
                <div className="form-group d-flex">
                  <input type="text" className="form-control" placeholder="Enter email address" style={{ fontSize: '0.9rem' }} />
                  <input type="submit" value="Subscribe" className="submit px-2" style={{ fontSize: '0.9rem' }} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>
    </div>
  );
};

export default Cart;
